// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

ion-header {
  background: var(--ion-color-primary);
}

ion-item {
  position: relative;
  max-height: 42px;
  border: 0.8px solid rgba(197, 197, 197, 0.4784313725);
  border-radius: var(--radius-default);
  --background: transparent !important;
  overflow: visible;
}
ion-item.input-error {
  border: 0.8px solid #cc0e0e;
}
ion-item ion-input {
  font-family: AppFont, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 127%;
  --padding-start: 14px;
  color: #1e1e1c;
}
ion-item:not(:has(ion-checkbox)) {
  display: flex;
  align-items: center;
}
ion-item:has(ion-checkbox) {
  border: none;
}
ion-item .input-error {
  border: 0.8px solid #cc0e0e;
}

.checkbox-item {
  display: flex;
  align-items: flex-start;
}
.checkbox-item ion-checkbox {
  --checkmark-color: #fff;
}

.din-pro-cond-med {
  margin-inline-start: 0;
  padding-top: 2px;
  font-family: AppFont;
  font-size: 10px;
  line-height: 16.9px;
  text-align: left;
  color: #1e1e1c;
}

.underline {
  color: inherit;
  position: relative;
  z-index: 10;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

ion-slide {
  width: 100% !important;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  text-align: left;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}
.phone-item ion-input {
  margin-bottom: 5px;
}

ion-card {
  margin: 0;
  margin-bottom: 10px;
  border-radius: var(--radius-default);
  text-align: initial;
  color: var(--color-black);
  overflow: auto;
  box-shadow: none;
  background: transparent;
  box-sizing: border-box;
}

.info-row:not(:last-child) {
  margin-bottom: 9px;
}

.left-col {
  padding: 0;
  padding-right: 5px;
  font-family: AppFont;
  font-size: 14px;
  line-height: 127%;
  font-weight: 400;
  color: #1e1e1c;
}

.right-col {
  padding: 0;
  font-family: AppFont;
  font-size: 11px;
  line-height: 13.37px;
  text-align: right;
  color: var(--color-black);
}

.tip-sum {
  font-family: AppFont;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0.07em;
  text-align: right;
}

.item-row {
  margin-bottom: 10px;
}

.arcticle-name-col,
.article-price-col {
  padding: 0;
  margin-bottom: 5px;
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 127%;
  font-weight: 400;
  color: #1e1e1c;
}

.article-price-col,
.option-price {
  font-family: AppFont;
  text-align: right !important;
}

.option-name,
.option-price {
  font-family: AppFont;
  font-size: 12px;
  line-height: 18.13px;
  text-align: left;
}

.price-title,
.price-sum {
  margin: 0;
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 127%;
  color: var(--color-black);
  letter-spacing: 0em;
  text-transform: capitalize;
}

.adds-price {
  font-family: AppFontSemiBold;
}

.price-sum {
  font-family: AppFontSemiBold;
  text-align: end;
}

ion-card-header {
  border-bottom: var(--outline-default);
  border-top: var(--outline-default);
  padding: 12px 0;
  margin: 0 auto;
}
ion-card-header ion-button {
  --background: #f0f7f8;
  --color: black;
  border: 1.5px solid #f0f7f8;
  text-transform: none;
  height: 30px;
  width: 30px;
  --border-radius: 50%;
  box-shadow: none;
  border: none;
  --box-shadow: none;
}

ion-card-content {
  padding: 12px 0;
  margin: 0 auto;
}
.border-top-light-blue {
  border-top: 0.5px solid #e5e5e5;
}

ion-card-title {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 600;
  line-height: 127%;
  letter-spacing: 0.03em;
  text-align: left;
  color: #1e1e1c;
}

ion-chip {
  margin: 0;
  padding: 0 6px;
  margin-left: auto;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 36px;
  height: 26px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #785526;
  border-radius: var(--radius-default);
}
ion-chip ion-label {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 16.2px;
  text-align: center;
  color: #fff;
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
}

.phone-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.phone-block ion-select {
  padding-bottom: 0;
  background: white;
  overflow: hidden;
  color: var(--ion-color-main);
  font-weight: 700;
  height: 68px;
  text-align: center;
  padding-top: 0;
  border-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
.phone-block ion-input {
  width: 70%;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}

.edit {
  display: flex;
  justify-content: flex-end;
}

ion-footer {
  padding: 22px;
  --background: #fff;
  background: #fff !important;
  box-shadow: -5px 0px 56px 0px rgba(0, 0, 0, 0.0901960784);
}

.padding {
  padding: 22px;
}

.icon-edit {
  height: 30px;
  width: 30px;
}

.privacy-content {
  padding: 13px 12px 14px;
}

.privacy {
  margin: 12px 0 0;
  font-family: AppFont;
  font-size: 12px;
  line-height: 16.55px;
  text-align: center;
  color: #1e1e1c;
}

.order-at-header {
  font-family: Capture;
  font-weight: normal;
  margin-top: 25px;
  color: var(--ion-color-secondary);
}

ion-checkbox {
  margin-left: 3px;
}

ion-checkbox {
  --background: transparent;
}

.sec-main-col {
  padding: 20px 16px;
}

.btn {
  width: 100%;
  height: 54px;
  outline: var(--outline-default);
  background: var(--ion-color-primary);
  border-radius: var(--radius-default);
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .btn {
    height: 67px;
  }
}
.btn span {
  font-family: AppFontBold;
  color: var(--color-white);
  font-size: 14px;
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}

.miles {
  border-top: 0.5px solid #311802;
  border-bottom: 0.5px solid #311802;
  margin: 12px 0;
  padding-inline: 12px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
}
.miles__img {
  width: 100px;
  height: 17px;
}
.miles__info {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.miles__info span {
  font-family: AppFontBoldAlt;
  font-size: 12px;
  line-height: 14.4px;
  color: #226086;
  width: 64%;
}
.miles__info.applied {
  width: 120px;
}
.miles__info.applied span {
  width: 100%;
}
.miles__icon {
  height: 20px;
  width: 20px;
}
.miles__icon.applied {
  height: 20px;
  width: 20px;
  flex-grow: 1;
}

.relative-block {
  position: relative;
}

.input-col {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.input-col:has([name=email]) {
  margin-bottom: 25px;
}
.input-col ion-label {
  max-width: 50%;
  font-family: AppFont;
  font-size: 14px;
  line-height: 127%;
  letter-spacing: 0.01em;
  text-transform: capitalize;
  color: var(--ion-color-black);
}

.table-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 26px;
  min-width: 40px;
  padding-inline: 6px;
  background-color: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-secondary);
  border-radius: 3px;
  cursor: pointer;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-white);
}
.table-chip ion-icon {
  --icon-color: var(--ion-color-primary-contrast);
  width: 10px;
}

.info-card-content {
  width: 100%;
  padding-block: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-card-content ion-icon {
  height: 22px;
  width: 32px;
}
.info-card-content p {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 91%;
  padding-inline: 10px;
  margin: 0;
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 2%;
  text-align: start;
}

.info {
  background: #666666;
  color: #fff;
  padding: 7px;
}
.info .info-icon-col {
  display: flex;
}
.info .info-icon-col ion-icon {
  width: 18px;
  height: 18px;
}
.info p {
  color: #fff;
  font-size: 9px;
  margin: 0;
}

.order-summary-card {
  border-bottom: var(--outline-default);
}

.error-text-block {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  transform: translate(0px, -10%);
}
.error-text-block.phone {
  bottom: -15px;
}
.error-text-block.agb {
  bottom: -10px;
}
.error-text-block .error-text {
  color: #bd3636;
  font-family: AppFont;
  font-weight: 400;
  font-size: 8px;
  line-height: 127%;
}

.privacy-checkbox {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAIA;EACC,oCAAA;AADD;;AAIA;EACC,kBAAA;EACA,gBAAA;EACA,qDAAA;EACA,oCAAA;EACA,oCAAA;EACA,iBAAA;AADD;AAEC;EACC,2BAAA;AAAF;AAGC;EACC,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AADF;AAIC;EACC,aAAA;EACA,mBAAA;AAFF;AAKC;EACC,YAAA;AAHF;AAKC;EACC,2BAAA;AAHF;;AAOA;EACC,aAAA;EACA,uBAAA;AAJD;AAMC;EAEC,uBAAA;AALF;;AASA;EACC,sBAAA;EACA,gBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAPD;;AAUA;EACC,cAAA;EACA,kBAAA;EACA,WAAA;AAPD;;AAUA;EACC,sBAAA;EACA,uBAAA;AAPD;;AAUA;EACC,sBAAA;AAPD;AAQC;EACC,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AANF;;AAUA;EACC,YAAA;AAPD;AAQC;EACC,kBAAA;AANF;AAQC;EACC,kBAAA;AANF;;AAUA;EACC,SAAA;EACA,mBAAA;EAGA,oCAAA;EAEA,mBAAA;EACA,yBAAA;EACA,cAAA;EAEA,gBAAA;EACA,uBAAA;EACA,sBAAA;AAXD;;AAeC;EACC,kBAAA;AAZF;;AAgBA;EACC,UAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAdD;;AAiBA;EACC,UAAA;EAEA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EAEA,yBAAA;AAhBD;;AAmBA;EACC,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AAhBD;;AAmBA;EACC,mBAAA;AAhBD;;AAmBA;;EAEC,UAAA;EACA,kBAAA;EAEA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAjBD;;AAoBA;;EAEC,oBAAA;EACA,4BAAA;AAjBD;;AAoBA;;EAEC,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAjBD;;AAqBA;;EAEC,SAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;AAlBD;;AAqBA;EACC,4BAAA;AAlBD;;AAqBA;EACC,4BAAA;EACA,eAAA;AAlBD;;AAqBA;EAEC,qCAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AAnBD;AAqBC;EACC,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAnBF;;AAuBA;EACC,eAAA;EACA,cAAA;AApBD;AA2BA;EACC,+BAAA;AAzBD;;AA4BA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,cAAA;AA1BD;;AA6BA;EACC,SAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,oCAAA;AA3BD;AA4BC;EACC,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA1BF;;AA8BA;EACC,kBAAA;AA3BD;;AA8BA;EACC,iBAAA;AA3BD;;AA8BA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3BD;AA4BC;EACC,iBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,2BAAA;AA3BF;AA6BC;EACC,UAAA;EACA,8BAAA;EACA,2BAAA;AA3BF;;AA+BA;EACC,aAAA;EACA,yBAAA;AA5BD;;AA8BA;EACC,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,yDAAA;AA3BD;;AAiCA;EACC,aAAA;AA9BD;;AAgCA;EACC,YAAA;EACA,WAAA;AA7BD;;AAgCA;EACC,uBAAA;AA7BD;;AAgCA;EACC,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AA7BD;;AAgCA;EACC,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AA7BD;;AAgCA;EACC,gBAAA;AA7BD;;AAgCA;EACC,yBAAA;AA7BD;;AAgCA;EACC,kBAAA;AA7BD;;AAgCA;EACC,WAAA;EACA,YAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7BD;AC5UE;EDiWF;IAWE,YAAA;EA5BA;AACF;AA8BC;EACC,wBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AA5BF;;AAgCA;EACC,+BAAA;EACA,kCAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AA7BD;AA+BC;EACC,YAAA;EACA,YAAA;AA7BF;AA+BC;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7BF;AA8BE;EACC,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AA5BH;AA+BC;EACC,YAAA;AA7BF;AA+BE;EACC,WAAA;AA7BH;AAiCC;EACC,YAAA;EACA,WAAA;AA/BF;AAkCC;EACC,YAAA;EACA,WAAA;EACA,YAAA;AAhCF;;AAoCA;EACC,kBAAA;AAjCD;;AAoCA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAjCD;AAmCC;EACC,mBAAA;AAjCF;AAoCC;EACC,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,6BAAA;AApCF;;AAwCA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;EACA,eAAA;EACA,mBAAA;EAEA,4CAAA;EACA,4CAAA;EACA,kBAAA;EAEA,eAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AAzCD;AA2CC;EACC,+CAAA;EACA,WAAA;AAzCF;;AA6CA;EACC,WAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA1CD;AA4CC;EACC,YAAA;EACA,WAAA;AA1CF;AA6CC;EACC,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,oBAAA;EAEA,SAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA5CF;;AA+CA;EACC,mBAAA;EACA,WAAA;EACA,YAAA;AA5CD;AA6CC;EACC,aAAA;AA3CF;AA4CE;EACC,WAAA;EACA,YAAA;AA1CH;AA6CC;EACC,WAAA;EACA,cAAA;EACA,SAAA;AA3CF;;AA8CA;EACC,qCAAA;AA3CD;;AA6CA;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;AA1CD;AA4CC;EACC,aAAA;AA1CF;AA4CC;EACC,aAAA;AA1CF;AA4CC;EACC,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA1CF;;AA8CA;EACC,gBAAA;AA3CD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:root {\n\t--ion-padding: 12px;\n}\n\nion-header {\n\tbackground: var(--ion-color-primary);\n}\n\nion-item {\n\tposition: relative;\n\tmax-height: 42px;\n\tborder: 0.8px solid #c5c5c57a;\n\tborder-radius: var(--radius-default);\n\t--background: transparent !important;\n\toverflow: visible;\n\t&.input-error {\n\t\tborder: 0.8px solid #cc0e0e;\n\t}\n\n\tion-input {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 127%;\n\t\t--padding-start: 14px;\n\t\tcolor: #1e1e1c;\n\t}\n\n\t&:not(:has(ion-checkbox)) {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t&:has(ion-checkbox) {\n\t\tborder: none;\n\t}\n\t.input-error {\n\t\tborder: 0.8px solid #cc0e0e;\n\t}\n}\n\n.checkbox-item {\n\tdisplay: flex;\n\talign-items: flex-start;\n\n\tion-checkbox {\n\t\t// margin-top: -3px;\n\t\t--checkmark-color: #fff;\n\t}\n}\n\n.din-pro-cond-med {\n\tmargin-inline-start: 0;\n\tpadding-top: 2px;\n\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 16.9px;\n\ttext-align: left;\n\tcolor: #1e1e1c;\n}\n\n.underline {\n\tcolor: inherit;\n\tposition: relative;\n\tz-index: 10;\n}\n\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nion-slide {\n\twidth: 100% !important;\n\t> ion-col {\n\t\toverflow: auto;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tposition: absolute;\n\t\ttext-align: left;\n\t}\n}\n\n.phone-item {\n\tborder: none;\n\tion-input:first-child {\n\t\tmargin-right: 10px;\n\t}\n\tion-input {\n\t\tmargin-bottom: 5px;\n\t}\n}\n\nion-card {\n\tmargin: 0;\n\tmargin-bottom: 10px;\n\n\t// border: 0.6px solid #9caeb9;\n\tborder-radius: var(--radius-default);\n\n\ttext-align: initial;\n\tcolor: var(--color-black);\n\toverflow: auto;\n\t// box-shadow: 0px 0px 15px 0px #7d5d281a;\n\tbox-shadow: none;\n\tbackground: transparent;\n\tbox-sizing: border-box;\n}\n\n.info-row {\n\t&:not(:last-child) {\n\t\tmargin-bottom: 9px;\n\t}\n}\n\n.left-col {\n\tpadding: 0;\n\tpadding-right: 5px;\n\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 127%;\n\tfont-weight: 400;\n\tcolor: #1e1e1c;\n}\n\n.right-col {\n\tpadding: 0;\n\n\tfont-family: AppFont;\n\tfont-size: 11px;\n\tline-height: 13.37px;\n\ttext-align: right;\n\n\tcolor: var(--color-black);\n}\n\n.tip-sum {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 16.8px;\n\tletter-spacing: 0.07em;\n\ttext-align: right;\n}\n\n.item-row {\n\tmargin-bottom: 10px;\n}\n\n.arcticle-name-col,\n.article-price-col {\n\tpadding: 0;\n\tmargin-bottom: 5px;\n\n\tfont-family: AppFontSemiBold;\n\tfont-size: 14px;\n\tline-height: 127%;\n\tfont-weight: 400;\n\tcolor: #1e1e1c;\n}\n\n.article-price-col,\n.option-price {\n\tfont-family: AppFont;\n\ttext-align: right !important;\n}\n\n.option-name,\n.option-price {\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 18.13px;\n\ttext-align: left;\n\t// text-transform: uppercase;\n}\n\n.price-title,\n.price-sum {\n\tmargin: 0;\n\tfont-family: AppFontSemiBold;\n\tfont-size: 14px;\n\tline-height: 127%;\n\tcolor: var(--color-black);\n\tletter-spacing: 0em;\n\ttext-transform: capitalize;\n}\n\n.adds-price {\n\tfont-family: AppFontSemiBold;\n}\n\n.price-sum {\n\tfont-family: AppFontSemiBold;\n\ttext-align: end;\n}\n\nion-card-header {\n\t// background: white;\n\tborder-bottom: var(--outline-default);\n\tborder-top: var(--outline-default);\n\tpadding: 12px 0;\n\tmargin: 0 auto;\n\n\tion-button {\n\t\t--background: #f0f7f8;\n\t\t--color: black;\n\t\tborder: 1.5px solid #f0f7f8;\n\t\ttext-transform: none;\n\t\theight: 30px;\n\t\twidth: 30px;\n\t\t--border-radius: 50%;\n\t\tbox-shadow: none;\n\t\tborder: none;\n\t\t--box-shadow: none;\n\t}\n}\n\nion-card-content {\n\tpadding: 12px 0;\n\tmargin: 0 auto;\n\n\t&:not(:last-child) {\n\t\t// border-bottom: 0.5px solid #a2834f;\n\t}\n}\n\n.border-top-light-blue {\n\tborder-top: 0.5px solid #e5e5e5;\n}\n\nion-card-title {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tline-height: 127%;\n\tletter-spacing: 0.03em;\n\ttext-align: left;\n\n\tcolor: #1e1e1c;\n}\n\nion-chip {\n\tmargin: 0;\n\tpadding: 0 6px;\n\tmargin-left: auto;\n\twidth: fit-content;\n\tmin-width: 36px;\n\theight: 26px !important;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: #785526;\n\tborder-radius: var(--radius-default);\n\tion-label {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 14px;\n\t\tline-height: 16.2px;\n\t\ttext-align: center;\n\t\tcolor: #fff;\n\t}\n}\n\n.card-content-md {\n\tfont-weight: unset;\n}\n\n.adds-price {\n\tpadding-left: 5px;\n}\n\n.phone-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tion-select {\n\t\tpadding-bottom: 0;\n\n\t\tbackground: white;\n\t\toverflow: hidden;\n\t\tcolor: var(--ion-color-main);\n\t\tfont-weight: 700;\n\t\theight: 68px;\n\t\ttext-align: center;\n\t\tpadding-top: 0;\n\t\tborder-radius: 0px;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-top-left-radius: 0px;\n\t}\n\tion-input {\n\t\twidth: 70%;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-top-left-radius: 0px;\n\t\t// padding: 8px 0px 8px 0px !important;\n\t}\n}\n.edit {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\nion-footer {\n\tpadding: 22px;\n\t--background: #fff;\n\tbackground: #fff !important;\n\tbox-shadow: -5px 0px 56px 0px #00000017;\n\n\t// &:has(.tip-row) {\n\t// \tbox-shadow: -5px 0px 56px 0px #00000017;\n\t// }\n}\n.padding {\n\tpadding: 22px;\n}\n.icon-edit {\n\theight: 30px;\n\twidth: 30px;\n}\n\n.privacy-content {\n\tpadding: 13px 12px 14px;\n}\n\n.privacy {\n\tmargin: 12px 0 0;\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 16.55px;\n\ttext-align: center;\n\tcolor: #1e1e1c;\n}\n\n.order-at-header {\n\tfont-family: Capture;\n\tfont-weight: normal;\n\tmargin-top: 25px;\n\tcolor: var(--ion-color-secondary);\n}\n\nion-checkbox {\n\tmargin-left: 3px;\n}\n\nion-checkbox {\n\t--background: transparent;\n}\n\n.sec-main-col {\n\tpadding: 20px 16px;\n}\n\n.btn {\n\twidth: 100%;\n\theight: 54px;\n\toutline: var(--outline-default);\n\tbackground: var(--ion-color-primary);\n\tborder-radius: var(--radius-default);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t@include desktop {\n\t\theight: 67px;\n\t}\n\n\tspan {\n\t\tfont-family: AppFontBold;\n\t\tcolor: var(--color-white);\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 19.2px;\n\t\tletter-spacing: 0.01em;\n\t}\n}\n\n.miles {\n\tborder-top: 0.5px solid #311802;\n\tborder-bottom: 0.5px solid #311802;\n\tmargin: 12px 0;\n\tpadding-inline: 12px;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 50px;\n\twidth: 100%;\n\n\t&__img {\n\t\twidth: 100px;\n\t\theight: 17px;\n\t}\n\t&__info {\n\t\tflex-grow: 1;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tspan {\n\t\t\tfont-family: AppFontBoldAlt;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 14.4px;\n\t\t\tcolor: #226086;\n\t\t\twidth: 64%;\n\t\t}\n\t}\n\t&__info.applied {\n\t\twidth: 120px;\n\n\t\tspan {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&__icon {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t}\n\n\t&__icon.applied {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tflex-grow: 1;\n\t}\n}\n\n.relative-block {\n\tposition: relative;\n}\n\n.input-col {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 16px;\n\n\t&:has([name='email']) {\n\t\tmargin-bottom: 25px;\n\t}\n\n\tion-label {\n\t\tmax-width: 50%;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 127%;\n\t\tletter-spacing: 0.01em;\n\t\ttext-transform: capitalize;\n\n\t\tcolor: var(--ion-color-black);\n\t}\n}\n\n.table-chip {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 8px;\n\n\theight: 26px;\n\tmin-width: 40px;\n\tpadding-inline: 6px;\n\n\tbackground-color: var(--ion-color-secondary);\n\tborder: 1px solid var(--ion-color-secondary);\n\tborder-radius: 3px;\n\n\tcursor: pointer;\n\n\tfont-family: AppFontBold;\n\tfont-size: 12px;\n\tline-height: 100%;\n\tletter-spacing: 0%;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n\tcolor: var(--color-white);\n\n\tion-icon {\n\t\t--icon-color: var(--ion-color-primary-contrast);\n\t\twidth: 10px;\n\t}\n}\n\n.info-card-content {\n\twidth: 100%;\n\tpadding-block: 12px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tion-icon {\n\t\theight: 22px;\n\t\twidth: 32px;\n\t}\n\n\tp {\n\t\twidth: fit-content;\n\t\tmax-width: 91%;\n\t\tpadding-inline: 10px;\n\n\t\tmargin: 0;\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 2%;\n\t\ttext-align: start;\n\t}\n}\n.info {\n\tbackground: #666666;\n\tcolor: #fff;\n\tpadding: 7px;\n\t.info-icon-col {\n\t\tdisplay: flex;\n\t\tion-icon {\n\t\t\twidth: 18px;\n\t\t\theight: 18px;\n\t\t}\n\t}\n\tp {\n\t\tcolor: #fff;\n\t\tfont-size: 9px;\n\t\tmargin: 0;\n\t}\n}\n.order-summary-card {\n\tborder-bottom: var(--outline-default);\n}\n.error-text-block {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 100%;\n\ttransform: translate(0px, -10%);\n\n\t&.phone {\n\t\tbottom: -15px;\n\t}\n\t&.agb {\n\t\tbottom: -10px;\n\t}\n\t.error-text {\n\t\tcolor: #bd3636;\n\t\tfont-family: AppFont;\n\t\tfont-weight: 400;\n\t\tfont-size: 8px;\n\t\tline-height: 127%;\n\t}\n}\n\n.privacy-checkbox {\n\toverflow: hidden;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
